    <h3 mat-dialog-title>Find References</h3>
    <mat-dialog-content  *ngIf="!processing">
        This process will pull all Script Values from Skill Custom Scripts, Skill Suppression Scripts,XS Settings, Script Schedules, and Script Actions (Runsub,Spawn,RunScript)
        We have found {{totalProcessCount}} locations to check.  This process can take some time based on the number of script locations to check.
    </mat-dialog-content>
        <mat-dialog-content class="saveDialog" *ngIf="processing">
            <mat-progress-bar [mode] = "progressMode" mode="determinate" value="{{completeProgress()}}"></mat-progress-bar>
            Found: {{references.length}} Script Skill References<br/>
            Checking: ({{currentProcessIndex + 1}} of {{totalProcessCount}})<br/>
            Processing: {{processingFileName}}
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button  mat-raised-button class="mat-raised-button mat-secondary" (click)="cancelProcess()">Cancel</button>&nbsp;&nbsp;
            <button  mat-raised-button class="mat-raised-button mat-primary"  (click)="findScriptUsages()">Start</button>&nbsp;&nbsp;
        </mat-dialog-actions>
